// @ts-strict
import Alert from "@/components/shared/Alert";
import ExternalLink from "@/components/shared/ExternalLink";

interface CompromisedPasswordAlertProps {
  showBanner: boolean;
  onCloseBanner: () => void;
}

export const CompromisedPasswordAlert = ({
  showBanner,
  onCloseBanner
}: CompromisedPasswordAlertProps) => {
  if (!showBanner) {
    return null;
  }

  return (
    <Alert
      variant="warning"
      title="Your password is vulnerable"
      icon="lock"
      onDismiss={onCloseBanner}
      className="relative z-[310] w-full rounded-none border-x-0 px-[30px] py-3.5"
    >
      According to <ExternalLink href="https://haveibeenpwned.com/">haveibeenpwned.com</ExternalLink>,
      you may be using a compromised password. Read more about how we determine this and what actions you should take in the{" "}
      <ExternalLink href="https://docs.replicated.com/vendor/vendor-password-integrity">
        password integrity documentation
      </ExternalLink>.
    </Alert>
  );
};
